import { THEME_ENUM } from 'constants/theme.constant'

/**
 * Since some configurations need to be match with specific themes, 
 * we recommend to use the configuration that generated from demo.
 */

export const themeConfig = {
    themeColor: 'custom',
    direction: THEME_ENUM.DIR_LTR,
    mode: THEME_ENUM.MODE_LIGHT,
    locale: 'en',
    primaryColorLevel: 600,
    cardBordered: true,
    panelExpand: false,
    controlSize: 'md',
    navMode: 'dark',
    layout: {
        type: THEME_ENUM.LAYOUT_TYPE_MODERN,
        sideNavCollapse: false,
    },
    colors: {
        primary: '#042663', // SalesWorkx Navy — primary actions
        secondary: '#0d3b8d', // Lighter navy
        success: '#7ED321', // Success / Activate only
        accent: '#FF6B00', // SalesWorkx Flame Orange
    },
}
